import { ProductQA } from "@/src/types/product";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

interface Props {
    qas: ProductQA[];
    productTitle?: string;
}

const ProductFAQ: React.FC<Props> = ({ qas, productTitle }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": qas.map((qa) => ({
            "@type": "Question",
            "name": qa.product_question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": qa.product_answer,
            },
        })),
    };

    return (
        <section
            className="w-full max-w-3xl mx-auto my-12 px-4 sm:px-6"
            aria-label="سوالات متداول محصول"
        >
            {/* تگ مهم بالای FAQ */}
            <div className="flex items-center gap-2 mb-3">
                <span
                    className="px-3 py-1 rounded-full shadow-md text-xs font-bold"
                    style={{
                        background: "#B5CB19",
                        color: "#1a1a1a", // رنگ نوشته تیره
                    }}
                >
                    مهم!
                </span>
                <span
                    className="text-base font-semibold"
                    style={{ color: "#B5CB19" }}
                >
                    سوالات متداول و پاسخ‌های مهم محصول
                </span>
            </div>

            <h2
                className="text-lg sm:text-xl font-bold mb-6 border-b-2 pb-2 tracking-wide"
                style={{ borderColor: "#B5CB19", color: "#1a1a1a" }}
            >
                {productTitle ? `سوالات متداول درباره ${productTitle}` : "سوالات متداول"}
            </h2>

            <div className="space-y-4">
                {qas.map((qa, idx) => (
                    <div
                        key={qa.id}
                        className={`
                rounded-2xl shadow-xl border-2 transition-all
                ${openIndex === idx
                                ? ''
                                : 'hover:scale-102'
                            }
              `}
                        style={{
                            borderColor: "#B5CB19",
                            background: openIndex === idx ? "#F9FBF3" : "#fff",
                        }}
                    >
                        <button
                            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                            className={`
                  w-full flex justify-between items-center px-6 py-4 transition-all text-right group
                  font-semibold
                  ${openIndex === idx ? 'text-[#B5CB19]' : 'text-gray-800 dark:text-gray-100'}
                `}
                            aria-expanded={openIndex === idx}
                            aria-controls={`faq-answer-${qa.id}`}
                            id={`faq-question-${qa.id}`}
                            type="button"
                        >
                            <span className="text-base sm:text-lg flex items-center gap-2">
                                <svg className="w-5 h-5" fill="#B5CB19" viewBox="0 0 20 20">
                                    <circle cx="10" cy="10" r="10" />
                                    <text x="10" y="15" textAnchor="middle" fontSize="12" fill="#fff">?</text>
                                </svg>
                                {qa.product_question}
                            </span>
                            <ChevronDown
                                className={`transition-transform duration-300 ml-2 ${openIndex === idx ? "rotate-180" : ""}`}
                                size={20}
                                color="#B5CB19"
                            />
                        </button>

                        <div
                            id={`faq-answer-${qa.id}`}
                            role="region"
                            aria-labelledby={`faq-question-${qa.id}`}
                            hidden={openIndex !== idx}
                            className={`
                  transition-all px-6 pb-5 text-[15px] leading-relaxed
                  ${openIndex === idx ? "block text-gray-700 dark:text-gray-300" : "hidden"}
                `}
                            style={{
                                background: "#F9FBF3", // کمی روشن‌تر از سبز برند برای تاکید
                                borderRadius: '0 0 18px 18px',
                            }}
                        >
                            <span className="block font-semibold mb-1" style={{ color: "#B5CB19" }}>
                                پاسخ:
                            </span>
                            {qa.product_answer}
                        </div>
                    </div>
                ))}
            </div>

            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
            />
        </section>


    );
};

export default ProductFAQ;
